import { CommonChartService } from './../../services/common-chart.service';
import { CommonService } from 'app/services/common.service';
import { Component, OnInit } from '@angular/core';
import { regexpPatterns } from '../../shared/patterns';
@Component({
  selector: 'app-college-social-graph', 
  templateUrl: './college-social-graph.component.html',
  styleUrls: ['./college-social-graph.component.scss']
})
export class CollegeSocialGraphComponent implements OnInit {

  detailEnrollmentData: any;
  detailTerminalDegreeData: any;
  detailGenderData: any;
  detailClassSizeData: any;
  detailDiversityData: any;
  detailSororitiesData: any;
  detailFraternitiesData: any;
  totalUnderGraduate;
  pattern = regexpPatterns.comma;
  setRaceEtinicityDataArray = [];
  setGenderDataArray = [];
  setSororitiesDataArray = [];
  setFraternitiesDataArray = [];
  terminalDegreeArray = [];
  terminalData;
  dataLoaded = true;
  terminalDegree;
  gender;
  raceEthnicity;
  sororities;
  fraternities;
  total;
  airforceROTC: any;
  armyROTC: any;
  navyROTC: any;
  musicAvailableLists: [];

  constructor(private _commonService: CommonService, 
    private commonChartService: CommonChartService
    ) { }

  setGenderData() {
    this.setGenderDataArray = [];
    this.detailGenderData.forEach((item: any) => {
      const totalCount = item.female + item.male;
      const avgMaleCount = (item.male * 100) / totalCount;
      const avgFemaleCount = (item.female * 100) / totalCount;
      const total = Math.round(avgMaleCount) + Math.round(avgFemaleCount);
      this.setGenderDataArray.push({
        name: 'Male',
        y: !total ? 'N/A' : (isNaN(total) ? 'N/A' : Math.round(avgMaleCount)),
        extraValue: Math.round(avgMaleCount),
        color: 'rgb(242, 193, 125)'
      });
      this.setGenderDataArray.push({
        name: 'Female',
        y: !total ? 'N/A' : (isNaN(total) ? 'N/A' : Math.round(avgFemaleCount)),
        extraValue: Math.round(avgFemaleCount),
        color: 'rgb(101, 218, 167)'
      });

    });
    this.gender = this.commonChartService.chartCommonData({
      data: this.setGenderDataArray,
      name: 'Gender'
    });
  };

  setTerminalDegreeData() {
    this.terminalDegreeArray = [];
    // TODO: Need to revisit this for possible refactor. Similar logic in other areas (e.g. college-info)
    this.terminalDegreeArray.push({
      name: 'Terminal Degree',
      y: Math.ceil(this.detailTerminalDegreeData),
      extraValue: Math.ceil(this.detailTerminalDegreeData),
      color: '#7b98ed'
    });
    this.terminalDegreeArray.push({
      name: 'Non-Terminal Degree',
      y: Math.ceil(100 - this.detailTerminalDegreeData) !== 100 ? Math.ceil(100 - this.detailTerminalDegreeData) : 'N/A',
      extraValue: Math.ceil(100 - this.detailTerminalDegreeData) !== 100 ? Math.ceil(100 - this.detailTerminalDegreeData) : 'N/A',
      color: '#f3719e'
    });
    this.terminalData = this.commonChartService.chartCommonData({
      data: this.terminalDegreeArray,
      name: 'Terminal Degree'
    });
  }

  setRaceEtinicityData() {
    this.setRaceEtinicityDataArray = [];
    this.total = 0;
    const colorArray = ['#f2719d', '#a57ee7', '#7f97e9', '#f2c17d', '#65daa7', '#ff3e7f', '#cc7700', '#16ca7c', '#06b8e4'];
    if (this.detailDiversityData) {
      this.detailDiversityData.forEach((item: any, i: number) => {
        this.total += item['value'];
        this.setRaceEtinicityDataArray.push({
          name: item['name'],
          y: Math.ceil(item['value']),
          extraValue: Math.ceil(item['value']),
          color: colorArray[i]
        });
      });
    }
    this.raceEthnicity = this.commonChartService.chartCommonData({
      data: this.setRaceEtinicityDataArray,
      name: 'RaceEtinicity',
      totalValue: this.total
    });
  }

  setSororitiesData() {
    this.setSororitiesDataArray = [];
    this.setSororitiesDataArray.push({
      name: 'Percentage of Females in Sororities',
      y: Math.ceil(this.detailSororitiesData['percentJoining']),
      extraValue: Math.ceil(this.detailSororitiesData['percentJoining']).toString(),
      color: '#7b98ed'
    });
    this.setSororitiesDataArray.push({
      name: 'Non-Greek Females',
      y: 100 - Math.ceil(this.detailSororitiesData['percentJoining']) !== 100 ? 100 - Math.ceil(this.detailSororitiesData['percentJoining']) : ' ',
      extraValue: 100 - Math.ceil(this.detailSororitiesData['percentJoining']) !== 100 ? 100 - Math.ceil(this.detailSororitiesData['percentJoining']) : ' ',
      sliced: false, color: '#f3719e'
    });
    const soroObj = {
      data: this.setSororitiesDataArray,
      name: 'Sororities'
    };
    this.sororities = this.commonChartService.chartCommonData(soroObj);
  }

  setFraternitiesData() {
    this.setFraternitiesDataArray = [];
    this.setFraternitiesDataArray.push({
      name: 'Percentage of Males in Fraternities',
      y: Math.ceil(this.detailFraternitiesData['percentJoining']),
      extraValue: Math.ceil(this.detailFraternitiesData['percentJoining']).toString(),
      color: '#7b98ed'
    });
    this.setFraternitiesDataArray.push({
      name: 'Non-Greek Males',
      y: 100 - Math.ceil(this.detailFraternitiesData['percentJoining']) !== 100 ? 100 - Math.ceil(this.detailFraternitiesData['percentJoining']) : ' ',
      extraValue: 100 - Math.ceil(this.detailFraternitiesData['percentJoining']) !== 100 ? 100 - Math.ceil(this.detailFraternitiesData['percentJoining']) : ' ',
      sliced: false,
      color: '#f3719e'
    });
    this.fraternities = this.commonChartService.chartCommonData({
      data: this.setFraternitiesDataArray,
      name: 'Fraternities'
    });
  }

  ngOnInit() {
    this._commonService.getData().subscribe(detailData => {
      if (detailData && detailData['collegeDetailAtaGlance']) {
        this.totalUnderGraduate = detailData['collegeDetailAtaGlance'].enrollment.toString().replace(this.pattern, '$1,');
      }
      if (detailData && detailData['collegeDetailSocialCampusStatistics']) {
        this.detailClassSizeData = detailData['collegeDetailSocialCampusStatistics'].classSize;
        this.detailEnrollmentData = detailData['collegeDetailSocialCampusStatistics'].enrollment;
        this.detailTerminalDegreeData = detailData['collegeDetailSocialCampusStatistics'].terminalDegree;
        this.detailGenderData = detailData['collegeDetailSocialCampusStatistics'].gender;
        this.detailDiversityData = detailData['collegeDetailSocialCampusStatistics'].diversity;
        this.detailSororitiesData = detailData['collegeDetailSocialCampusStatistics'].sororities;
        this.detailFraternitiesData = detailData['collegeDetailSocialCampusStatistics'].fraternities;
        this.airforceROTC = detailData['collegeDetailSocialCampusStatistics'].airforceROTC;
        this.armyROTC = detailData['collegeDetailSocialCampusStatistics'].armyROTC;
        this.navyROTC = detailData['collegeDetailSocialCampusStatistics'].navyROTC;
        this.musicAvailableLists = detailData['collegeDetailSocialCampusStatistics'].musicAvailableLists;
        this.setGenderData();
        this.setRaceEtinicityData();
        this.setSororitiesData();
        this.setFraternitiesData();
        this.setTerminalDegreeData();
        this.dataLoaded = false;
      }
    });
  }
}

